import { apiConfigs } from "@payping/api";
import type { HandlerType, StatusHandlersTypes } from "@payping/api";
import { setShowTOTPModal } from "@payping/redux/actions";
import { message } from "@payping/web-components";
import * as Sentry from "@sentry/react";

import { userManager } from "@/utils/userManager";
import { jotaiStore, store } from "./index";
import { dashboardPreferencesAtom } from "./core/state";

const generalHandler: HandlerType = (error) => {
  // key is a constant because there should be at most one message error from api
  message.error({ content: error.message, duration: 3, key: "api error" });
};

const statusHandlers: StatusHandlersTypes = {
  "401": async () => {
    const currentRoute = `${window.location.pathname}${window.location.search}`;
    if (!currentRoute.toLowerCase().includes("login") && !currentRoute.toLowerCase().includes("logout")) {
      const currentValue = jotaiStore.get(dashboardPreferencesAtom);
      jotaiStore.set(dashboardPreferencesAtom, { ...currentValue, urlForLoginRedirect: currentRoute });
    }
    userManager.signinRedirect();
    // eslint-disable-next-line import/namespace
    Sentry.configureScope((scope) => scope.setUser(null));
  },
  "412": async () => {
    await store.dispatch(setShowTOTPModal(true));
  },
  default: generalHandler,
};

const domain = process.env.REACT_APP_DOMAIN || "";

const networkChecker = new Promise<void>((resolve) => {
  resolve();
});

apiConfigs.updateConfig({
  // set 30 second timeout for non-production environments due to low quality of servers
  timeout: 1000 * 30 * 10,
  domain,
  networkChecker,
  statusHandlers,
});
